var _path, _line, _line2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M123.439,62.5c-22.31-22.309-44.982,10.52-44.982,33.737,0,40.629,20.677,62.758,44.619,38.815"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 65.035,
    y1: 88.832,
    x2: 117.635,
    y2: 88.832
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 64.672,
    y1: 109.444,
    x2: 113.644,
    y2: 109.444
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stroke-color-main",
    cx: 100,
    cy: 100,
    r: 84.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.8b50bbfa638008da443664b68efe3e3d.svg";
export { ForwardRef as ReactComponent };